<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h1>FAQ</h1>
        <p>Stumpthespread strives to make this website intuitive and easy to use, however we know there will be many questions about the functionality of this site. This document should solve most of your questions. If it does not, please send us an email through our <a href="contact.php">contact</a> page.</p>
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        >
        </adsense>
        <br />
        <br />
        <h5>I just paid for premium picks, how do I view picks?</h5>
        <ul><li>Log into the website using the "Login" button found at the top right of the website. Once logged in, click "View Picks" which appears next to your email address also found in the top right of the website.</li></ul>
        <h5>Do you email picks?</h5>
        <ul><li>Yes, when you are a premium member, you can set up pick notifications for email or text message.</li></ul>
        <h5>Can I view picks on my smartphone?</h5>
        <ul><li>You can view the website in your smartphone's browser. We are currently working on a web app for smartphones to make it easier to view picks.</li></ul>
        <h5>I just registered for the website, how do I view free picks?</h5>
        <ul><li>Once logged in, click "Free Picks" in the navigation bar.</li></ul>
        <h5>I'm a premium member, how come the free picks do not show when I click "View Picks?"</h5>
        <ul><li>Free picks are of a lower confidence level therefore we do not include them in the "View Picks" view or in our Results page when they are not represented as a premium pick. If you would like to look at the free picks, you will have to click "Free Picks" found in the navigation bar.</li></ul>
        <h5>What are units?</h5>
        <ul><li>Units are a measurement of the size of a bet. This size is relative to your bankroll. A unit should be between 0.5 - 1% of your bankroll. For example, if you have $10,000 and we have a pick for 1 unit, that would be $50 - $100. Keeping your unit size small limits your risk of ruin.</li></ul>
        <h5>Most of your picks are for 1 unit, do you ever deviate from betting this unit?</h5>
        <ul><li>Our system calls for mainly 1 unit picks. When we deviate and bet more on a game it will be because it fits one of our high unit systems.</li></ul>
        <br>
        <p>If you have any further questions, please consult us via email at our <a href="contact.php">contact</a> page.</p>
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        >
        </adsense>
      </div>
      <!-- main-colum END here -->
      <!-- sidebar START here -->
      <sidebar :testimonial="testimonial"></sidebar>
    <!-- sidebar END here -->
    </div>
  <!-- container END here -->
  </div>
<!-- content END here -->
</template>

<script>
import Sidebar from '../components/sidebar.vue'
import Adsense from '../components/adsense.vue'
import TestimonialRepository from '../data/testimonial.repository.js'
export default {
  components: {
    'sidebar': Sidebar,
    'adsense': Adsense
  },
  data () {
    return {
      testimonial: {}
    }
  },
  created () {
    TestimonialRepository.getTestimonials(1).then(test => {
      this.testimonial = test
    })
  },
  metaInfo: {
    title: 'FAQ'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Faq.vue?2b4cbfd5